<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      show-close
      :size="1000"
      :title="$l('dialog_title_addUser') || '批量新增人员'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main ref="main" @close="close" @reload="$emit('reload')" />
      </div>
      <div class="d-flex justify-content-end" style="padding: 4px 20px 20px;">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { visible: { type: Boolean, default: false } },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
</style>
